// Single source of truth for seller details shown on the legal pages.
// Paddle's domain review checks that the seller name matches the verification form.
export const SELLER = {
  legalName: "NEXTWAVE TECHNOLOGIES LIMITED",
  tradingName: "Veylo AI",
  productName: "Veylo AI",
  website: "https://veyloai.online",
  supportEmail: "info@veyloai.online",
  country: "Nigeria",
  lastUpdated: "27 September 2026",
  refundDays: 30,
} as const;
